export default {
	name: "ItemStatistic",
	props: {
		statistic: {
			type: [Object],
			default: () => {
				return {
					views: 0,
					comments: 0,
					likes: 0
				};
			}
		},
	},
	template: '<div class="activity-block">' +
		'	<span class="art-count"><img' +
		'			src="/assets/images/icons/icon-view.svg"' +
		'			alt=""> {{statistic.views}}</span>' +
		'	<span class="art-count"><img' +
		'			src="/assets/images/icons/icon-comment.svg"' +
		'			alt=""> {{statistic.comments}}</span>' +
		'	<span class="art-count"><img' +
		'			src="/assets/images/icons/icon-like.svg"' +
		'			alt=""> {{statistic.likes}}</span>' +
		'</div>',
};
